// test1426
(1426 && 0);
